<vp-availability-widget-input
	[className]="className()"
	[disabled]="items().length === 1"
	[header]="label()"
	[iconName]="iconName()"
	[inputName]="inputName()"
	[isOpen]="isOpen()"
	[label]="label()"
	[placeholder]="placeholder()"
	[value]="selectedItem()?.name"
	(emitIsOpen)="popoverStateChanged($event)"
>
	<div
		class="flex max-h-[320px] min-w-64 flex-col overflow-y-auto overflow-x-hidden"
	>
		@if (items().length > 3 && searchable()) {
			<div class="p-4">
				<vp-input
					[icon]="'assets/icons/icon-looking-glass.svg'"
					[placeholder]="'components.widget.search-hotel' | translate"
					(emittedValue)="onSearchInput($event)"
					iconPosition="right"
					inputId="search-dropdown"
					name="search-dropdown"
				/>
			</div>
		}
		@for (item of dropdownItems(); track item) {
			<button
				[class]="
					cn(
						item.guid === selectedItem()?.guid && 'bg-secondary-75',
						'btn btn-text w-full justify-start text-base font-normal hover:bg-secondary-50'
					)
				"
				(click)="onSelectItem(item)"
				data-test-class="availability-item-selector-option"
			>
				{{ item.name }}
			</button>
		}
	</div>
	<div
		[attr.data-test-id]="inputName() + '-footer'"
		class="flex flex-col gap-4"
		widget-input-footer
	>
		<div class="text-center">
			<div class="justify-center text-center">
				<span class="text-sm text-dark-tertiary" data-test-id="summary">
					{{
						selectedItem()?.name
							? selectedItem()?.name
							: ('global.hotel-selection-placeholder' | translate)
					}}
				</span>
			</div>
		</div>
		<button
			[attr.data-test-id]="inputName() + '-cta-button'"
			[disabled]="!selectedItem()?.name"
			(click)="emitCta.emit($event)"
			class="btn btn-primary mt-auto w-full"
		>
			{{ 'global.choose-dates' | translate }}
		</button>
		<button
			[attr.data-test-id]="inputName() + '-back-button'"
			(click)="onEmitBackButton($event)"
			class="flex items-center gap-1 text-sm text-dark-primary"
		>
			<svg-icon
				class="inline-block h-auto w-3"
				src="assets/icons/icon-chevron-left.svg"
			/>
			{{ 'global.back' | translate }}
		</button>
	</div>
</vp-availability-widget-input>
